import { Button, Form } from "antd";
import ControlledInputBox from "../../components/ControlledInputBox";
import "./style.css";

/* const styles = {
  loginFormContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  loginForm: {
    display: "flex",
    flexDirection: "column",
    width: 400,
    border: "2px solid #f3f4f5",
    padding: 30,
    paddingTop: 20,
    borderRadius: 4,
  },
  heading: {
    fontFamily: "'B612', open-sans",
    fontSize: 32,
    marginBottom: 15,
    color: "#0a8080",
  },
}; */

const SetPasswordForm = ({ onSubmit, loading, control, errors }) => {
  return (
    <div className="loginFormContainer">
      <Form colon={false}>
        <div className="loginForm">
          <div
            style={{ borderBottom: "2px dashed #f3f4f5", marginBottom: "15px" }}
          >
            <p className="heading">Set Your Password</p>
          </div>
          <ControlledInputBox
            type="password"
            required
            control={control}
            errors={errors}
            name="password"
            placeholder="Super secret password"
            label="Password"
          />
          <ControlledInputBox
            type="password"
            required
            control={control}
            errors={errors}
            name="passwordConfirm"
            placeholder="One more time"
            label="Confirm Password"
          />
          <Button
            type="primary"
            size="large"
            disabled={loading}
            loading={loading}
            onClick={onSubmit}
          >
            Set Password and Verify
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default SetPasswordForm;
